export const GET_SHOP_USER_STAT = 'GET_SHOP_USER_STAT'
export const GET_SHOP_MERCHANT_STAT = 'GET_SHOP_MERCHANT_STAT'
export const GET_FEED_USER_STAT = 'GET_FEED_USER_STAT'
export const GET_STORY_USER_STAT = 'GET_STORY_USER_STAT'
export const GET_SHOP_USER_STAT_SUCCESS = 'GET_SHOP_USER_STAT_SUCCESS'
export const GET_SHOP_MERCHANT_STAT_SUCCESS = 'GET_SHOP_MERCHANT_STAT_SUCCESS'
export const GET_FEED_USER_STAT_SUCCESS = 'GET_FEED_USER_STAT_SUCCESS'
export const GET_STORY_USER_STAT_SUCCESS = 'GET_STORY_USER_STAT_SUCCESS'

